import { Component, computed, ElementRef, input, QueryList, ViewChildren } from '@angular/core';
import { AbstractControl, FormArray, FormControl, Validators } from '@angular/forms';

@Component({
  selector: 'empathy-choices-form',
  templateUrl: './choices-form.component.html',
  styleUrl: './choices-form.component.scss'
})
export class ChoicesFormComponent {
  @ViewChildren('questionOptions') questionOptions!: QueryList<ElementRef>;

  question = input<AbstractControl>();
  disabled = input<boolean>();
  isRankSort = input(false);

  options = computed(() => this.question().get(this.isRankSort() ? 'ranks' : 'options') as FormArray);

  private readonly MINIMUM_OPTIONS = this.isRankSort() ? 1 : 2;

  get optionsAsFormArray(): FormArray {
    return this.question().get(this.isRankSort() ? 'ranks' : 'options') as FormArray;
  }

  onJumpOption(index: number): void {
    this.questionOptions.get(index + 1)?.nativeElement.focus();
  }

  onAddOption(): void {
    this.optionsAsFormArray.push(new FormControl('', [Validators.required]));

    requestAnimationFrame(() => {
      this.questionOptions.last.nativeElement.focus();
    });
  }

  onDeleteOption(index: number): void {
    const optionsLength = this.optionsAsFormArray.controls.length;

    if (optionsLength > this.MINIMUM_OPTIONS) {
      const options = this.optionsAsFormArray;
      if (options.at(index).value === '') {
        options.removeAt(index);
        requestAnimationFrame(() => {
          if (index > 0) {
            const questionOptions = this.questionOptions;
            (questionOptions.get(index) ?? questionOptions.get(index - 1))?.nativeElement.focus();
          }
        });
      }
    }
  }

  onPaste(event: ClipboardEvent, pastedIndex: number): void {
    event.preventDefault();

    const clipboardData = event.clipboardData;
    const pastedData = clipboardData.getData('text/plain');

    this.optionsAsFormArray.at(pastedIndex).setValue('');

    // Split the pasted data into lines and add them as new options
    const newOptions = pastedData
      .split('\n')
      .map((option) => option.trim())
      .filter((option) => option !== '');

    newOptions.forEach((option, index) => {
      const indexToInsert = pastedIndex + index;
      if (!!this.optionsAsFormArray.at(indexToInsert)) {
        this.optionsAsFormArray.at(indexToInsert).setValue(option);
      } else {
        this.optionsAsFormArray.push(new FormControl(option, [Validators.required]));
      }
    });

    this.onAddOption();
  }
}
